// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__G08fH","photo480":"styles_photo480__Z3gxa","photo":"styles_photo__pAlZi"};